import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热门分类</h2>
        <Link to="/category/portrait" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-50 group-hover:bg-primary-500 transition-colors">
              <i className={`${c.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50`}></i>
            </div>
            <span className="text-xs md:text-sm font-label text-foreground-800 whitespace-nowrap">{c.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}